import { useState } from "react";
import Navigation from "../components/Navigation";
import AddTeam from "../components/teams/AddTeam";
import AddTeamModal from "../components/teams/AddTeamModal";
import TeamDetails from "../components/teams/TeamDetails";

export default function Team() {
    const [open, setOpen] = useState(false);
    
    const controlModal = () => {
        setOpen((prevState) => !prevState);
    };

    return (
        <div
            className="flex flex-col w-screen h-screen overflow-auto text-gray-700 bg-gradient-to-tr from-blue-200 via-indigo-200 to-pink-200"
        >
            <Navigation />
            <div className="px-10 mt-6 flex justify-between">
                <h1 className="text-2xl font-bold">Teams</h1>
                <AddTeam setOpen={setOpen}/>
                <AddTeamModal open = {open} control = {controlModal} />
            </div>
            <TeamDetails />
        </div>
    );
}
